import { render, staticRenderFns } from "./Kapplopning.vue?vue&type=template&id=6d25b0a6&scoped=true&"
import script from "./Kapplopning.vue?vue&type=script&lang=js&"
export * from "./Kapplopning.vue?vue&type=script&lang=js&"
import style0 from "./Kapplopning.vue?vue&type=style&index=0&id=6d25b0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25b0a6",
  null
  
)

export default component.exports